import '../feedbacks/feedbacks.css'
import { useGetAllQuestionQuery } from '../../services/feedbackApi'
import afatar from "../../images/femaleAfatar.png";
import { MailOutline } from "@mui/icons-material";
import { AdminPageHeader, AdminTable } from '../../components/ui'
import { formatDate } from '../../utils/format'

function Question() {
  const response = useGetAllQuestionQuery();
  const rows = (response.data || []).slice().reverse();

  const columns = [
    {
      key: "userName",
      header: "Sender",
      render: (q) => (
        <div className="feedbackReviewer">
          <img src={afatar} alt="" />
          <span>{q.userName}</span>
        </div>
      ),
    },
    { key: "email", header: "Email" },
    { key: "message", header: "Message", render: (q) => <span className="feedbackContent">{q.message}</span> },
    { key: "messageDate", header: "Date", render: (q) => formatDate(q.messageDate) },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Messages"
        subtitle="Questions submitted through the contact form."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Messages" }]}
      />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(q) => q.id}
        isLoading={response.isLoading}
        emptyIcon={<MailOutline />}
        emptyTitle={response.isError ? "Couldn't load messages" : "No messages yet"}
        emptyDescription={response.isError ? "Something went wrong. Try refreshing the page." : undefined}
        pageSize={10}
      />
    </div>
  );
}

export default Question
